export default __webpack_public_path__ + "static/media/gallery_02.f98af7ff.jpg";